import {getSavedConsent} from "./consent";

export function isScriptAllowed(scriptSlug: string): boolean {
    const consent = getSavedConsent()?.setting || {};

    return consent[scriptSlug];
}
